var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"referenceContainer"},[_c('ol',{staticClass:"references"},_vm._l((_vm.references),function(reference){return _c('li',[_c('span',[_vm._v(_vm._s(reference.text))]),_c('br'),(reference.link)?_c('a',{attrs:{"href":reference.link,"target":"_blank"}},[_vm._v(_vm._s(reference.link))]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }